export default __webpack_public_path__ + "static/media/deux.bf3824da.jpg";